
import { quotationsActions } from "./quotations.actions";

export default {
  
  ...quotationsActions,
};